var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "Invite Member",
            description:
              "Please fill in the following information to invite a new member.",
            footer: false
          }
        },
        [
          _c("div", { staticClass: "flex flex-col gap-4 pb-8 px-8" }, [
            _c(
              "div",
              { staticClass: "grid grid-cols-3" },
              _vm._l(_vm.invitationProgress, function(progress) {
                return _c(
                  "div",
                  {
                    key: progress.step,
                    staticClass: "flex flex-col gap-1 pb-1 border-b-4",
                    class:
                      progress.step <= _vm.currentStep
                        ? "border-light-purple"
                        : "border-light-purple-100"
                  },
                  [
                    _c("BlTextBody3", {
                      attrs: { text: "Step " + progress.step + ":" }
                    }),
                    _vm._v(" "),
                    _c("BlTextSubtitle2", {
                      class: {
                        "text-grey-400": progress.step > _vm.currentStep
                      },
                      attrs: { text: progress.label }
                    })
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.currentStep === 1
              ? _c(
                  "form",
                  {
                    staticClass: "flex flex-col gap-4",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        _vm.currentStep = 2
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      [
                        _c("BlInputText", {
                          attrs: { input: _vm.nameInput },
                          on: { changed: _vm.inputHandler }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          attrs: {
                            text:
                              "Invited users can change their name after logging in."
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlInputText", {
                      attrs: { input: _vm.emailInput },
                      on: { changed: _vm.onInputEmail }
                    }),
                    _vm._v(" "),
                    _c("BlSelectBox", {
                      attrs: {
                        label: "Role",
                        asterisk: "",
                        placeholder: "Select role",
                        options: _vm.roleOptions
                      },
                      on: {
                        change: function($event) {
                          _vm.roleInput = $event
                        }
                      },
                      model: {
                        value: _vm.roleInput,
                        callback: function($$v) {
                          _vm.roleInput = $$v
                        },
                        expression: "roleInput"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid grid-cols-2 lg:flex items-center justify-end gap-4"
                      },
                      [
                        _c("BlInputButton", {
                          attrs: { type: "plain", label: "Cancel" },
                          on: {
                            clicked: function($event) {
                              return _vm.$emit("close-modal")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlInputButton", {
                          attrs: {
                            label: "Next",
                            disabled: !_vm.Step1Verified,
                            buttonType: "submit"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep === 2
              ? _c("div", { staticClass: "flex flex-col gap-4" }, [
                  _c(
                    "div",
                    { staticClass: "flex flex-col" },
                    [
                      _c("BlTextSubtitle2", {
                        staticClass: "text-slate-1000",
                        attrs: { text: "Set password" }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "Choose how to set the password for new members' accounts."
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex gap-4 cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.passwordAutogenerated = true
                        }
                      }
                    },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          checked: _vm.passwordAutogenerated,
                          name: "autogenerated"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextSubtitle2", {
                            attrs: { text: "Autogenerated password" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "You can view the password after you create the user."
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex gap-4 cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.passwordAutogenerated = false
                        }
                      }
                    },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          checked: !_vm.passwordAutogenerated,
                          name: "autogenerated"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextSubtitle2", {
                            attrs: { text: "Custom password" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text: "Enter a custom password for the user."
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ml-8 flex flex-col gap-4" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.customPasswordInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid grid-cols-3" }, [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "rounded-full w-6 h-6",
                              class: [
                                _vm.passwordHasSixChar
                                  ? "bg-success-400"
                                  : "bg-grey-300"
                              ],
                              attrs: { icon: "check", color: "secondary" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-xs" }, [
                              _vm._v("6 characters minimum")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "rounded-full w-6 h-6",
                              class: [
                                _vm.passwordHasUppercase
                                  ? "bg-success-400"
                                  : "bg-grey-300"
                              ],
                              attrs: { icon: "check", color: "secondary" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-xs" }, [
                              _vm._v("1 uppercase character")
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid grid-cols-3" }, [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "rounded-full w-6 h-6",
                              class: [
                                _vm.passwordHasLowescase
                                  ? "bg-success-400"
                                  : "bg-grey-300"
                              ],
                              attrs: { icon: "check", color: "secondary" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-xs" }, [
                              _vm._v("1 lowercase character")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "rounded-full w-6 h-6",
                              class: [
                                _vm.passwordHasNumber
                                  ? "bg-success-400"
                                  : "bg-grey-300"
                              ],
                              attrs: { icon: "check", color: "secondary" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-xs" }, [
                              _vm._v("1 number")
                            ])
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-2 lg:flex items-center justify-end gap-4"
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "plain", label: "Cancel" },
                        on: {
                          clicked: function($event) {
                            return _vm.$emit("close-modal")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: { type: "outlined", label: "Back" },
                        on: {
                          clicked: function($event) {
                            _vm.currentStep = 1
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: { label: "Next", disabled: !_vm.Step2Verified },
                        on: {
                          clicked: function($event) {
                            _vm.currentStep = 3
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep === 3
              ? _c("div", { staticClass: "flex flex-col gap-4" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "py-4 px-6 flex flex-col gap-4 rounded-3xl bg-grey-100"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-12" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "col-span-2",
                            attrs: { text: "Name" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass:
                              "text-slate-1000 font-medium col-span-10",
                            attrs: { text: _vm.nameInput.model }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-12" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "col-span-2",
                            attrs: { text: "Email" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass:
                              "text-slate-1000 font-medium col-span-10",
                            attrs: { text: _vm.emailInput.model }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-12" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "col-span-2",
                            attrs: { text: "Role" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass:
                              "text-slate-1000 font-medium col-span-10",
                            attrs: { text: _vm.userRoles[_vm.roleInput] }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-12 items-center" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "col-span-2",
                            attrs: { text: "Password" }
                          }),
                          _vm._v(" "),
                          _vm.passwordAutogenerated
                            ? _c(
                                "div",
                                { staticClass: "col-span-10" },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-slate-1000 font-medium",
                                    attrs: { text: "Autogenerated" }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "col-span-10 flex items-center gap-2"
                                },
                                [
                                  _vm.showPassword
                                    ? _c("BlTextBody2", {
                                        staticClass:
                                          "text-slate-1000 font-medium",
                                        attrs: {
                                          text: _vm.customPasswordInput.model
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.showPassword
                                    ? _c("BlTextBody2", {
                                        staticClass:
                                          "text-slate-1000 font-medium",
                                        attrs: {
                                          text: _vm.customPasswordInput.model.replace(
                                            /[\S]/g,
                                            "*"
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("BlInputButton", {
                                    attrs: {
                                      type: "plain",
                                      label: _vm.showPassword ? "Hide" : "Show",
                                      dense: ""
                                    },
                                    on: {
                                      clicked: function($event) {
                                        _vm.showPassword = !_vm.showPassword
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-2 lg:flex items-center justify-end gap-4"
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "plain", label: "Cancel" },
                        on: {
                          clicked: function($event) {
                            return _vm.$emit("close-modal")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: { type: "outlined", label: "Back" },
                        on: {
                          clicked: function($event) {
                            _vm.currentStep = 2
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          label: "Create user",
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onSubmit }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.loginDetailsOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Send login details",
                description:
                  "Please be sure to save this information as it will not be accessible again once the pop-up is closed.",
                footer: false
              }
            },
            [
              _c("div", { staticClass: "flex flex-col gap-4 pb-8 px-8" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "py-4 px-6 flex flex-col gap-4 rounded-3xl bg-slate-100"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-12 items-center" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "col-span-2",
                          attrs: { text: "Sign in URL" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-span-10 flex items-center gap-2"
                          },
                          [
                            _c("BlInputButton", {
                              attrs: { type: "plain", icon: "copy" },
                              on: {
                                clicked: function($event) {
                                  return _vm.copyToClipboard(
                                    _vm.origin +
                                      "/setup-account/" +
                                      _vm.loginDetails.signInToken,
                                    "Sign in URL"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-slate-1000 font-medium",
                              attrs: {
                                text:
                                  _vm.origin +
                                  "/setup-account/" +
                                  _vm.loginDetails.signInToken
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-12 items-center" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "col-span-2",
                          attrs: { text: "Email" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-span-10 flex items-center gap-2"
                          },
                          [
                            _c("BlInputButton", {
                              attrs: { type: "plain", icon: "copy" },
                              on: {
                                clicked: function($event) {
                                  return _vm.copyToClipboard(
                                    _vm.loginDetails.email,
                                    "Email"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-slate-1000 font-medium",
                              attrs: { text: _vm.loginDetails.email }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-12 items-center" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "col-span-2",
                          attrs: { text: "Password" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-span-10 flex items-center gap-2"
                          },
                          [
                            _c("BlInputButton", {
                              attrs: { type: "plain", icon: "copy" },
                              on: {
                                clicked: function($event) {
                                  return _vm.copyToClipboard(
                                    _vm.loginDetails.password,
                                    "Password"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            !_vm.showPassword
                              ? _c("BlTextBody2", {
                                  staticClass: "text-slate-1000 font-medium",
                                  attrs: {
                                    text: _vm.loginDetails.password.replace(
                                      /[\S]/g,
                                      "*"
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showPassword
                              ? _c("BlTextBody2", {
                                  staticClass: "text-slate-1000 font-medium",
                                  attrs: { text: _vm.loginDetails.password }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("BlInputButton", {
                              attrs: {
                                type: "plain",
                                label: _vm.showPassword ? "Hide" : "Show",
                                dense: ""
                              },
                              on: {
                                clicked: function($event) {
                                  _vm.showPassword = !_vm.showPassword
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center justify-end gap-4" },
                  [
                    _c("BlInputButton", {
                      attrs: { type: "plain", label: "Close" },
                      on: {
                        clicked: function($event) {
                          return _vm.$emit("close-modal")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      attrs: {
                        type: "outlined",
                        label: "Download details",
                        loading: _vm.downloadLoading
                      },
                      on: { clicked: _vm.onDownloadDetails }
                    }),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      attrs: { label: "Send via email" },
                      on: { clicked: _vm.onSendViaEmail }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b938ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b938ed8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/NewUserModal.vue
// module id = null
// module chunks = 